import axios from "axios";
const BASE_URL = `${process.env.REACT_APP_BACK_END_URL}`;
const GoWorkLogInstance = axios.create({
  baseURL: BASE_URL,
});

// Module-level token holder. Login flow calls setAuthToken() once a Google
// ID token is obtained; the request interceptor then attaches it to every
// outgoing request so individual API files don't need to thread the token.
let authToken: string | undefined;
export const setAuthToken = (token: string | undefined) => {
  authToken = token;
};
GoWorkLogInstance.interceptors.request.use((config) => {
  if (authToken && !config.headers?.authorization && !config.headers?.Authorization) {
    config.headers = { ...config.headers, authorization: `Bearer ${authToken}` };
  }
  return config;
});

export default GoWorkLogInstance;
